let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4b0v1")).then(() => parcelRequire('b6vMw'));